import { Link } from "react-router-dom"

function Broken() {
  return (
     <section class="ser_v_araeea">
      <div class="container">
       <div className="row">
        <div className="col-lg-8">
         <div className="forchooro">
          <div className="middells">
           <h1>404</h1>
           <h6>Opps! Your Weyfarin Wandered Off...</h6>
           <p>Looks like this page has gone off-grid! But don't worry-you can always find you next adventure.</p>
           <Link to={'/'}>Find Your Next Adventure</Link>
          </div>
         </div>
        </div>
        <div className="col-lg-4">
         <div className="erro_mg"><img src="/images/fouderror.svg" alt="" /></div>
        </div>
       </div>

      </div>
     </section> 
  )
}

export default Broken